
import { Mixins, Component, Prop, VModel, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import { User } from '@/views/Project/PSI/types/psi'
import { Debounce } from 'lodash-decorators'
import { getRequest } from '@/plugins/api-axios'
import { deserialise } from 'kitsu-core'
import UserAvatar from '@/views/User/components/userAvatar.vue'

@Component({
    inheritAttrs: false,
    name: 'UserAutocomplete',
    components: { UserAvatar },
})
export default class UserAutocomplete extends Mixins<MixinInterface>() {
    @VModel({}) user!: User | null
    @Prop({ default: process.env.VUE_APP_USER_BASE_URL }) baseUrl!: string
    @Prop({ default: 'users' }) endpoint!: string
    @Prop({ default: null }) filters!: Record<string, any> | null
    @Prop({ default: () => ['employer'] }) include!: Array<string> | null

    items: Array<User> = []
    isDirty = false
    searchTerm = ''
    loading = false
    offset = 0
    limit = 20
    infiniteID = new Date().getTime()
    @Watch('isDirty')
    @Watch('searchTerm')
    toggleLoading() {
        if (this.isDirty) {
            this.loading = true
        }
    }

    @Debounce(500)
    @Watch('searchTerm')
    @Watch('isDirty')
    async load() {
        this.loading = true

        if (this.isDirty && this.searchTerm !== this.user?.name) {
            this.offset = 0
            this.items = []
            this.infiniteID = new Date().getTime()
            this.items = await this.searchUsers()
        }
        this.loading = false
    }

    async loadMore($state) {
        if (this.offset >= this.limit) {
            this.loading = true
            let res = await this.searchUsers()
            if (!res) {
                $state.complete()
                return
            }
            this.items = [...this.items, ...res]

            if (res.length == this.limit) {
                $state.loaded()
            } else {
                $state.complete()
            }

            this.loading = false
        } else {
            $state.complete()
        }
    }

    async searchUsers() {
        let { data } = await getRequest(
            this.getURL({
                path: this.endpoint,
                base: this.baseUrl,
                params: {
                    ...(this.filters && { ...this.filters }),
                    ...(this.searchTerm &&
                        this.searchTerm.length > 1 && { 'filter[searchTerm]': this.searchTerm }),
                    'page[limit]': this.limit,
                    'page[offset]': this.offset,
                    ...(this.include && { include: this.include.join(',') }),
                },
            }),
            this.getRequestHeaders('GET')
        ).catch(() => {
            this.loading = false
            return false
        })

        if (!data) {
            return null
        }

        let res = deserialise(data).data

        this.offset = this.offset + res.length

        return res
    }
}
